import React from "react";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { batchUpdateShippingAddress } from "@/services/api/order";
import { buildShippingAddressInfo } from "@/utils/OrderUtils";
import { useRequest } from "ahooks";
import { Form, message, Modal, Select } from "antd";
import { observer } from "mobx-react-lite";
import { getList } from "@/services/api/setting/shippingAddress";
import OrderDTO from "@/dto/order/OrderDTO";

interface UpdateShippingAddressModalProps extends InjectBaseModalProps {
    shopId: number;
    tab: OrderTab;
    orders: OrderDTO[];
}

const UpdateShippingAddressModal: React.FC<UpdateShippingAddressModalProps> = function (props) {
    const { open, onCancel, shopId, tab, orders } = props;
    const orderManagementStore = useOrderManagementStore();

    const { loading, runAsync } = useRequest(batchUpdateShippingAddress, { manual: true });
    const { loading: loading2, data: shippingAddresses = [] } = useRequest(() => getList(false));

    const [form] = Form.useForm<{ shippingAddressId: number }>();

    async function handleOk() {
        const { shippingAddressId } = form.getFieldsValue();
        const orderIds = orders.map(({ id }) => id);

        let shipperName;

        if (shippingAddressId) {
            const shippingAddress = shippingAddresses.find(({ id }) => id === shippingAddressId);

            if (shippingAddress) {
                shipperName = shippingAddress.shipperName;
            }
        }

        await runAsync({ orderIds, shippingAddressId, shopId, shipperName });

        onCancel();

        message.success("修改成功");

        orderManagementStore.fetchOrders(shopId, tab);
    }

    return (
        <Modal
            title="批量修改发货人"
            open={open}
            onCancel={onCancel}
            mask={{ closable: false }}
            onOk={handleOk}
            okButtonProps={{
                loading,
            }}
        >
            <Form form={form}>
                <Form.Item label="发货人" name="shippingAddressId">
                    <Select
                        allowClear
                        showSearch={{
                            optionFilterProp: "label",
                            filterOption: true,
                        }}
                        placeholder="可输入发货人信息快速搜索"
                        data-openreplay-masked
                        loading={loading2}
                        options={[
                            ...(shippingAddresses?.map((shippingAddress) => {
                                if (shippingAddress.deleted) return null;
                                return {
                                    key: shippingAddress.id,
                                    value: shippingAddress.id,
                                    "data-openreplay-masked": true,
                                    label: buildShippingAddressInfo(shippingAddress),
                                };
                            }) ?? []),
                        ]}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default observer(UpdateShippingAddressModal);
